export const mapAndSortAlphabetically = (
    data = [],
    labelKey = "value",
    valueKey = "value"
) => {
    return [...data]
        .sort((a, b) =>
            (a[labelKey] || "")
                .toLowerCase()
                .localeCompare((b[labelKey] || "").toLowerCase())
        )
        .map(item => ({
            value: item[valueKey],
            label: item[labelKey],
        }));
};